import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { Button, Menu } from '@mui/material';
import React, { useState } from 'react';
import { DOWNLOAD_OPTIONS } from './billsDownload';

/**
 * A bill's own Download (LB-6033), beside Retry, Delete and Close in its details: the footer's two downloads, for this
 * bill alone.
 */
export function BillDownloadButton(_ref) {
  let className = _ref.className,
    _ref$disabledReason = _ref.disabledReason,
    disabledReason = _ref$disabledReason === void 0 ? null : _ref$disabledReason,
    _ref$isBusy = _ref.isBusy,
    isBusy = _ref$isBusy === void 0 ? false : _ref$isBusy,
    onPick = _ref.onPick;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchor = _useState2[0],
    setAnchor = _useState2[1];
  const pick = kind => {
    setAnchor(null);
    onPick(kind);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    "aria-expanded": Boolean(anchor),
    "aria-haspopup": "menu",
    "aria-label": "Download this bill",
    className: className,
    disabled: Boolean(disabledReason) || isBusy,
    onClick: event => setAnchor(event.currentTarget),
    title: disabledReason || (isBusy ? 'Preparing…' : 'Download this bill'),
    type: "button"
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "grey",
    type: "download"
  })), /*#__PURE__*/React.createElement(Menu, {
    anchorEl: anchor,
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    elevation: 0,
    onClose: () => setAnchor(null),
    open: Boolean(anchor),
    transformOrigin: {
      horizontal: 'right',
      vertical: 'top'
    },
    type: "action-menu"
  }, DOWNLOAD_OPTIONS.map(option => /*#__PURE__*/React.createElement(Button, {
    key: option.kind,
    onClick: () => pick(option.kind),
    variant: "menuAction"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: option.icon
  }), option.oneBillLabel))));
}